var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"position":"fixed","top":"0","left":"0","bottom":"0","right":"0","width":"100%","height":"100%","border":"none","margin":"0","padding":"0","overflow":"hidden","z-index":"999999"},attrs:{"src":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }